import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesVentas() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Pedidos", items: [
      { label: "Pedidos", icon: "fas fa-shopping-basket", color: "#3b82f6", href: "/ListadoPedidos", desc: "Listado de pedidos", enabled: !!user.menu_pedidos },
      // "Pedidos por Cliente" (/ListadoPedidosCliente) se quito: la vista nunca
      // existio ni estaba registrada en Routes.js, el boton llevaba a una
      // pantalla en blanco. Venia asi desde antes de la migracion de menus.
      { label: "Listo para Surtir", icon: "fas fa-dolly", color: "#f59e0b", href: "/ListoSurtir", desc: "Surtibles por almacen", enabled: !!user.menu_surtidos },
      { label: "Consignaciones", icon: "fas fa-handshake", color: "#6366f1", href: "/ListadoConsignaciones", desc: "Vino con clientes y liquidaciones", enabled: !!user.menu_consignaciones },
    ]},
    { section: "Surtidos y Notas", items: [
      { label: "Surtir", icon: "fas fa-truck-moving", color: "#10b981", href: "/ListadoPendienteSurtir", desc: "Pendientes de surtir", enabled: !!user.surtidos_create },
      { label: "Ventas", icon: "fas fa-file-invoice-dollar", color: "#10b981", href: "/ListadoVentas", desc: "Notas de venta y entregas", enabled: !!user.menu_ventas },
      { label: "Venta Directa", icon: "fas fa-file-invoice-dollar", color: "#14b8a6", href: "/VentaDirectaCreate", desc: "Venta sin pedido", enabled: !!user.ventas_create },
      { label: "Notas de Cargo", icon: "fas fa-money-check-alt", color: "#f59e0b", href: "/ListadoNotasCargo", desc: "Cargos al cliente", enabled: !!user.notasCargo },
      { label: "Utilidades", icon: "fas fa-search-dollar", color: "#10b981", href: "/ReporteUtilidades", desc: "Utilidad por venta y por vino", enabled: !!user.menu_reportes },
    ]},
    { section: "Devoluciones", items: [
      { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#ef4444", href: "/ListadoDevoluciones", desc: "Devoluciones de cliente", enabled: !!user.menu_devoluciones },
    ]},
    { section: "Clientes", items: [
      { label: "Clientes", icon: "fas fa-user-tie", color: "#64748b", href: "/Clientes", desc: "Padron de clientes", enabled: !!user.menu_clientes },
      { label: "Zonas", icon: "fas fa-map-marker-alt", color: "#64748b", href: "/Zonas", desc: "Zonas de reparto", enabled: !!user.menu_departamentos },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Ventas"
      descripcion="Pedidos, surtidos, notas y devoluciones"
      icono="fas fa-store"
      color="#10b981"
      secciones={SECCIONES}
    />
  );
}

export default BotonesVentas;
